import { Component, Inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Input, Optional, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { ServiceGroup } from 'src/app/modules/status-page/service-catalog/service-groups-list/service-groups-list.component';
import { nonWhitespaceHtmlValidator, sanitizeInputForCrossSiteScriptCharactersDom } from 'src/app/_theme/core/_base/curd/utils/validators-util';

export interface GroupDialogData {
    mode: 'add' | 'edit';
    group?: ServiceGroup;
}

@Component({
    selector: 'app-group-dialog',
    templateUrl: './group-dialog.component.html',
    styleUrls: ['./group-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule
]
})
export class GroupDialogComponent implements OnInit {
    groupForm: FormGroup;
    isSaving = false;
    @Input() data: GroupDialogData = { mode: 'add' };
    @Output() saveAction = new EventEmitter<any>();
    @Output() closed = new EventEmitter<void>();

    constructor(
        @Optional() public dialogRef: MatDialogRef<GroupDialogComponent> | null,
        @Optional() @Inject(MAT_DIALOG_DATA) private readonly dialogData: GroupDialogData | null,
        private readonly fb: FormBuilder,
        public cdr: ChangeDetectorRef,
        private readonly sanitizer: DomSanitizer
    ) {
        this.groupForm = this.fb.group({
            name: ['', [
                Validators.required,
                Validators.minLength(3),
                nonWhitespaceHtmlValidator(),
                sanitizeInputForCrossSiteScriptCharactersDom(this.sanitizer)
            ]],
            description: ['', [sanitizeInputForCrossSiteScriptCharactersDom(this.sanitizer)]]
        });
    }

    ngOnInit(): void {
        if (this.dialogData) {
            this.data = this.dialogData;
        }
    }

    onCancel(): void {
        if (this.isSaving) {
            return;
        }

        if (this.dialogRef) {
            this.dialogRef.close();
            return;
        }

        this.closed.emit();
    }

    onSave(): void {
        if (this.groupForm.invalid) {
            this.groupForm.markAllAsTouched();
            return;
        }

        const result = {
            ...this.groupForm.value
        };

        this.isSaving = true;
        this.cdr.markForCheck();
        this.saveAction.emit(result);
    }

}
